import * as commonScripts from '../common'
import Glide from '@glidejs/glide'

const cmpStrategyDetailDetailCard = {
  component: null,

  init: function (element) {
    const _ = this
    const viewport = commonScripts.util.getViewportSize()
    _.component = element

    commonScripts.util.animationTranslate(this)
    commonScripts.util.inheritPermalink(element)

    // If not in edit mode and the viewport size is mobile, then initialize the carousel
    if (!commonScripts.util.isEditMode() && viewport.width < 768) {
      const carouselDiv = _.component.querySelector('.glide')

      if (carouselDiv) {
        const autoplay = _.component.getAttribute('data-autoplay')
        let loop = _.component.getAttribute('data-loop')
        loop = loop ? loop.toLowerCase() : loop
        const bullets = _.component.querySelectorAll('.glide__bullet')
        const options = {}
        options.type = (loop === 'true') ? 'carousel' : 'slider'
        options.autoplay = (isNaN(autoplay) || autoplay === '0') ? false : (autoplay * 1000)
        options.rewind = false
        let slideCount = carouselDiv.querySelectorAll('.glide__slide');
          if (slideCount.length > 1) {
            const glide = new Glide(carouselDiv, options).mount()
            // Add listeners and rules for custom bullets.
            // Custom bullets needed when the markup is not within the .glide element.
            for (let i = 0; i < bullets.length; i++) {
                const bullet = bullets[i]
    
                if (i === 0) {
                _.updateBullets(bullets, i)
                }
    
                bullet.addEventListener('click', function (event) {
                glide.go('=' + i)
                })
            }
    
            glide.on('run', function () {
                _.updateBullets(bullets, glide._i)
            })

          } else{
            let bulletsDiv = carouselDiv.querySelector('.glide__bullets');
            if(bulletsDiv){
                bulletsDiv.style.display = 'none'
            }
          }

        
      }
    }
  },
  updateBullets: function (bullets, index) {
    for (let i = 0; i < bullets.length; i++) {
      bullets[i].classList.remove('glide__bullet--active')
    }
    bullets[index].classList.add('glide__bullet--active')
  }

}

export default cmpStrategyDetailDetailCard
